import type { Locale } from '@fastnorth/i18next';

export const FALLBACK_LANGUAGE: Locale = 'en-US';
export const DEFAULT_LOCALE: Locale = 'en-US';
export const DEFAULT_LOCAL_STORAGE_USER_LOCALE_KEY = 'user-locale';
export const LOCAL_STORAGE_NAMESPACE = 'rr-results-v3';
export const LOCAL_STORAGE_CLIENT_UUID_KEY = 'client-uuid';
export const LOCAL_STORAGE_DECLINE_NOTIFICATIONS_KEY = 'declineNotifications';
export const DEFAULT_TIMEZONE_NAME = 'America/New_York';
export const FALLBACK_BASE_DOMAIN = 'raceroster.com';
export const GEOLOCATION_ACCURACY = 40;

export const KEYS = {
  dataDogRUMClientToken: 'pub8d698e149bbc79ca3b300d1ee43d56e3',
  dataDogRUMApplicationId: '16719358-4242-4090-a096-56635e32d287',
};

export const SERVICE_NAMES = {
  dataDogRUM: 'results-karwa',
};

export enum RACE_STATUS {
  starting = 'STARTING',
  inProgress = 'IN_PROGRESS',
  complete = 'COMPLETE',
  dnf = 'DNF',
  dns = 'DNS',
  dnq = 'DNQ',
}

export const BLANK_SEGMENT_VALUE = '--';
export const BLANK_VALUE = '--';

export const RACEROSTER_CDN_BASE_URL = 'https://cdn.raceroster.com';
export const RACEROSTER_HOME_URL = 'https://www.raceroster.com';
export const RESULTS_BASE_URLS = {
  local: 'results.local.ue1dev1.rostrr.net:5600',
  ue1dev1: 'results.ue1dev1.rostrr.net',
  ue1dev2: 'results.ue1dev2.rostrr.net',
  ue1live: 'results.raceroster.com',
};

export const GRAPHQL_API_URLS: Record<string, string> = {
  local: '/api/graphql/public',
  ue1dev1: 'https://ue1dev1.rostrr.net/api/graphql/public',
  ue1dev2: 'https://ue1dev2.rostrr.net/api/graphql/public',
  ue1live: 'https://raceroster.com/api/graphql/public',
};

export const ACTIVE_MARKER_FILL_COLOR = '#060';
export const RACE_ROSTER_BLUE = '#0043bf';
export const GRAY_900 = '#1a1a1a';

// Public LaunchDarkly client side IDs
export const LAUNCH_DARKLY_CLIENT_SIDE_IDS = {
  ue1dev1: '670f016b082e3d085941f0fb',
  ue1dev2: '670f0180922861082aba181e',
  ue1live: '67169edf5ddba2081bb0f2ab',
};

export enum StripeClientId {
  us_dev = 'pk_test_51RWfiRQ9AOL3U1qmHB4HIaTzjxE62SOB6fMGYeh4oSWk9JcSfmgDQ7UMf5GVvKBnF56tlbJ2BBiRYb2kNQOha8yV00QF4JvoCZ',
  us_live = 'pk_live_BEvhQVVNiVaIhNo4Rg5hlPdJ',
}

export const PWA_VAPID_KEYS = {
  local: 'BDYSyFe9qjBXpTVB1iy7D7ACk1Ce3nCsRrjh5DaI9YnsHnTbG0RTANo-7VTvrXM-2DqXL_KzsLzc6QdpOP2J3y8',
  ue1dev1:
    'BEiWwNVmjxQz_DhGZkAY7hQvrD02TaxaAYWpucinr6QEqnoOQL7ehF8LNGpxpIl7dfX4gWCCDb8ESIdLo7X2b_w',
  ue1dev2:
    'BLCYYMKjxgHv5uWakDRKytsWZxXyeWdNi_CaGhUUltcMD3-hT1yvlSYmgdjnz_ON1_VcgKqQczJJ9WawL7mg7N0',
  ue1live:
    'BLxvkAJDNiZibPXH19OQQtZvNv_Ou2xtPu5wEU2bYkWz5uPBm1Hh3AI3AG46Fw5ZVz-xFM9h6CITdmOuNDr-bWA',
};

export const MAP_Z_INDEX = {
  routePath: 100,
  knownPath: 200,
  knownMarker: 225,
  predictedPath: 250,
  userLocation: 255,
  customMarker: 260,
  estimatedFinishPath: 265,
  estimatedFinishMarker: 270,
  predictedMarker: 275,
};

export const PUBLIC_GOOGLE_RECAPTCHA_KEY: string = '6Lcbu3AUAAAAABlYMKWpow68W7ceL3bcAd_DNxMO';
